import React from "react";
import BodyContainer from "../components/BodyContainer";
import BottomContainer from "../components/BottomContainer";
import Footer from '../components/Footer';
import FooterLinks from "../components/FooterLinks";
import Banner from '../components/Banner';
import bannerImage from '../assets/banner4.png';
import { Helmet } from "react-helmet-async";
import "../Site.css";
import "../LegalPages.css"; // use same styling as privacy/terms

function Contact() {
  return (
    <>
      <Helmet>
        <title>PharmPrepPro - Contact Us</title>
      </Helmet>
      <BottomContainer>
        <Banner height="300px" image={bannerImage} />
        <BodyContainer>
          <div className="legal-section">
            <p className="legal-paragraph">
              For questions about our Products and Accounts/Subscriptions, Please Reach out to Us at:
            </p>
            <p className="legal-paragraph">
              <strong>Email:</strong> <a href="mailto:contactus.pharmpreppro@gmail.com" className="legal-link">
                pharmpreppro@gmail.com
              </a>
            </p>
          </div>
        </BodyContainer>
      </BottomContainer>
      <FooterLinks />
      <Footer />
    </>
  );
}

export default Contact;
